var map = {
	"./de.png": 9952,
	"./en.png": 44,
	"./es.png": 3785,
	"./eye.png": 9862,
	"./fr.png": 9185,
	"./hamburger-white.png": 3520,
	"./hamburger.png": 3728,
	"./icon-batches-blue.png": 6000,
	"./icon-batches.png": 5337,
	"./icon-campaign-blue.png": 3658,
	"./icon-campaign.png": 5627,
	"./icon-dashboard-blue.png": 8236,
	"./icon-dashboard.png": 5277,
	"./icon-discount-codes-blue.png": 4908,
	"./icon-discount-codes.png": 8957,
	"./icon-events-blue.png": 7057,
	"./icon-events.png": 3686,
	"./icon-extension-blue.png": 8565,
	"./icon-extension.png": 2626,
	"./icon-layouts-blue.png": 8879,
	"./icon-layouts.png": 1812,
	"./icon-logout-blue.png": 3222,
	"./icon-orders-blue.png": 8077,
	"./icon-orders.png": 3770,
	"./icon-reports-blue.png": 1315,
	"./icon-reports.png": 8336,
	"./icon-scan-center-blue.png": 7413,
	"./icon-scan-center.png": 1474,
	"./icon-settings-blue.png": 9793,
	"./icon-settings.png": 118,
	"./nl.png": 5095,
	"./pt.png": 5309,
	"./trash.png": 7495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5994;